interface IProps {
    showPitches: boolean,
    activeVoice: number,
    voice: number,
    currentNote: {
        bar: number,
        note: number,
    },
    barNoteIndex: number,
    barIndex: number,
};

const getIsShow = ({ showPitches, activeVoice, voice, currentNote, barNoteIndex, barIndex }: IProps) =>
    !showPitches ||
    (currentNote &&
        (!showPitches ||
            activeVoice > voice ||
            (activeVoice === voice && barIndex < currentNote.bar) ||
            (activeVoice === voice && barIndex === currentNote.bar && barNoteIndex < currentNote.note)));

export default getIsShow;
